import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Form from '../../../../components/form/Form';
import Input from '../../../../components/form/formComponents/Input';
import SubmitButton from '../../../../components/form/formComponents/SubmitButton';
import TextArea from '../../../../components/form/formComponents/TextArea';
import FileUpload from '../../../../components/fileUpload/FileUpload';

import AmbassadorImage from '../../../../components/ambassador/AmbassadorImage.jsx';

import i18n from '../../../../../shared/locales/no.json';

export default class AmbassadorForm extends React.Component {
    static propTypes = {
        id: PropTypes.number,
        image: PropTypes.object,
        fullName: PropTypes.string,
        jobTitle: PropTypes.string,
        quote: PropTypes.string,
        text: PropTypes.string,
        onUpdateImage: PropTypes.func,
        onSave: PropTypes.func.isRequired,
        onCompletion: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    };

    state = {
        currentImage: this.props.image,
        imagePreviewUrl: this.props.image && this.props.image.urls.default,
        inProgress: false,
    };

    handleImage = (imgFile) => {
        this.setState({ currentImage: imgFile });

        const self = this;
        const reader = new FileReader();

        reader.readAsDataURL(imgFile);
        reader.onload = (file) => {
            self.setState({ imagePreviewUrl: file.target.result });
        };

        if (this.props.onUpdateImage) {
            this.props.onUpdateImage(this.props.id, imgFile);
        }
    };

    handleSubmit = (model) => {
        const { id, onSave, onCompletion } = this.props;

        if (!this.state.currentImage) {
            this.setState({ imageUploadError: true });
            return false;
        }

        this._startProgress();

        return (
            id
                ? onSave(id, this.state.currentImage, model)
                : onSave(this.state.currentImage, model)
        )
            .then(this._stopProgress)
            .then(onCompletion);
    };

    _startProgress() {
        this.setState({ inProgress: true });
    }

    _stopProgress = () => {
        this.setState({ inProgress: false });
    };

    render() {
        const { fullName, jobTitle, quote, text } = this.props;

        const fileUploadError =
            this.state.imageUploadError && !this.state.image;
        const fileUploadClasses = cx([
            'input',
            fileUploadError && 'input--is-invalid',
        ]);

        return (
            <div>
                {this.state.imagePreviewUrl && (
                    <div className="u-text-center">
                        <AmbassadorImage
                            imageUrl={this.state.imagePreviewUrl}
                        />
                    </div>
                )}

                <div className={fileUploadClasses}>
                    <FileUpload
                        classes="button fullwidth"
                        inProgress={this.state.inProgress}
                        onFileSubmit={this.handleImage}
                    >
                        Last opp bilde
                    </FileUpload>

                    {fileUploadError && (
                        <div className="input__sub-text">
                            Du må laste opp et bilde
                        </div>
                    )}
                </div>

                <Form onValidSubmit={this.handleSubmit}>
                    <Input
                        classes="input input--text"
                        id="ambassador_full_name"
                        label={i18n.ambassadors.name}
                        maxLength={50}
                        name="fullName"
                        required
                        type="text"
                        validationErrorMsg={i18n['Required field']}
                        value={fullName}
                    />

                    <Input
                        classes="input input--text"
                        id="ambassador_job_title"
                        label={i18n.ambassadors.job_title}
                        maxLength={50}
                        name="jobTitle"
                        required
                        type="text"
                        validationErrorMsg={i18n['Required field']}
                        value={jobTitle}
                    />

                    <TextArea
                        classes="input input--textarea"
                        id="ambassador_quote"
                        label={i18n.ambassadors.quote}
                        maxLength={100}
                        name="quote"
                        required
                        rows={3}
                        validationErrorMsg={i18n['Required field']}
                        validations="maxLength:100"
                        value={quote}
                    />

                    <TextArea
                        classes="input input--textarea"
                        id="ambassador_text"
                        label={i18n.ambassadors.text}
                        maxLength={500}
                        name="text"
                        required
                        rows={5}
                        validationErrorMsg={i18n['Required field']}
                        validations="maxLength:500"
                        value={text}
                    />

                    <SubmitButton
                        className="button--cta u-mr8"
                        value={i18n['Save button']}
                    />
                    <button
                        className="button"
                        onClick={this.props.onCancel}
                        type="button"
                    >
                        {i18n.cancel}
                    </button>
                </Form>
            </div>
        );
    }
}
